// pagination params object for desktop
export const defaultPaginationParams = {
  totalPages: null, // count of total pages required for the pagination
  currentPage: 1, // value of current page
  offset: 0, // offset from the current page
  productsLengthPerPage: 104, // used for calculating the length of total required pages
  length: 104, // length of the page
  totalFetchedProducts: null, // total number of products fetched
  enableContentTile: false,
  fetchedProductsCount: 104, // total number of products fetched so far
}

// handling page number update in URL
const updatePageNumberInURL = (pageNoFromParams) => {
  const url = new URL(window.location.href)
  const searchParams = url.searchParams
  searchParams.set('page', pageNoFromParams.toString())
  url.search = searchParams.toString();
  const newURL = url.href
  window.history.pushState({ path: newURL }, '', newURL);
}

// calculates the offset by page no.
const getOffsetByPageNo = (pageNo, offset) => {
  switch (pageNo) {
    case 1:
      return 102;
    default:
      return offset + 104;
  }
}

// handle the length of previous page based on the current page
const handlePreviousPageLength = (pageNo) => {
  switch (pageNo - 1) {
    case 1:
      return 102;
    default:
      return 104
  }
}

// handle the offset of previous page based on the current page
const handlePreviousPageOffset = (pageNo, offset) => {
  switch (pageNo - 1) {
    case 1:
      return 0;
    case 2:
      return 102
    default:
      return offset - 104
  }
}

// calculate the pagination params for a given page
// Same function is used to set default offset and length at first render
// defaultValue prop is created to eliminate calling of updatePageNumberInURL func
export const getPaginationParamsByPageNo = (payload, paginationParams, defaultValue=false) => {
  const { page: pageNo, shouldChangeURL } = payload
  if (shouldChangeURL && !defaultValue) {
    updatePageNumberInURL(pageNo)
  }
  const getOffsetForGivenPage = (page) => {
    let initialOffset = 0;
    let firstPageOffset = 102;
    if (paginationParams.enableContentTile) {
      switch (page) {
        case 1:
          return initialOffset
        case 2:
          return firstPageOffset
        default:
          return (page - 2) * 104 + firstPageOffset
      }
    }
    else {
      return (page - 1) * 104
    }
  }

  const getLengthForGivenPage = (page) => {
    if (paginationParams.enableContentTile) {
      switch (page) {
        case 1:
          return 102
        default:
          return 104
      }
    }
    else {
      return 104
    }
  }

  return {
    ...paginationParams,
    currentPage: pageNo,
    offset: getOffsetForGivenPage(pageNo),
    length: getLengthForGivenPage(pageNo),
  }
}


// pagination helper reducer function
export const paginationHelper = (state, action) => {
  const { type, payload } = action
  switch (type) {

    // common utility actions
    case "ADD_TOTAL_PAGES_COUNT":
      return { ...state, totalPages: payload }
    case "ADD_TOTAL_PRODUCTS_COUNT":
      return { ...state, totalFetchedProducts: payload }
    case "UPDATE_INITIAL_PAGINATION_PARAMS":
      return { ...state, ...payload }
    case "RESET_PAGINATION_PARAMS":
      return { payload }

    // utility actions to handle mobile pagination
    case "FETCH_NEXT_PAGE_MOBILE":
      return {
        ...state,
        currentPage: state.currentPage + 1,
        // length: state.currentPage + 1 === state.totalPages ? state.length + (state.totalFetchedProducts - state.length) : state.length + state.productsLengthPerPage, // for demo use this
        length: state.length + state.productsLengthPerPage > 1000 ? state.length : state.length + state.productsLengthPerPage, // do not use for demo
        offset: state.length + state.productsLengthPerPage > 1000 ? state.productsLengthPerPage : 0, // new added
        fetchedProductsCount: state.currentPage + 1 === state.totalPages ? state.length + (state.totalFetchedProducts - state.length) : state.length + state.productsLengthPerPage // new added
      }

    // utility actions to handle desktop pagination
    case "FETCH_NEXT_PAGE_DESKTOP":
      updatePageNumberInURL(state.currentPage + 1)
      return {
        ...state,
        currentPage: state.currentPage + 1,
        offset:
          state.enableContentTile ? getOffsetByPageNo(state.currentPage, state.offset) : state.offset + state.productsLengthPerPage,
        length: 104,
      }
    case "FETCH_PREVIOUS_PAGE_DESKTOP":
      updatePageNumberInURL(state.currentPage - 1)
      return {
        ...state,
        currentPage: state.currentPage - 1,
        offset: state.enableContentTile ? handlePreviousPageOffset(state.currentPage, state.offset) : state.offset - state.productsLengthPerPage,
        length: state.enableContentTile ? handlePreviousPageLength(state.currentPage) : 104
      }
    case "GO_TO_FIRST_PAGE":
      updatePageNumberInURL(1)
      return {
        ...state,
        currentPage: 1,
        offset: 0,
        length: state.enableContentTile ? 102 : 104,
      }
    case "FETCH_DATA_FOR_SELECTED_PAGE":
      return getPaginationParamsByPageNo(payload, state)


    default:
      return state
  }
}
